import { render } from "./Teams.vue?vue&type=template&id=a0f8212c"
import script from "./Teams.vue?vue&type=script&lang=js"
export * from "./Teams.vue?vue&type=script&lang=js"

import exportComponent from "/home/leandro/trabalho-timo/kuhlenbier-web-frontend-partner/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__